/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, September 22nd 2021, 11:44:01 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

export const TRANSLATIONS_SW = {
  Edit: "Badilisha",
  Delete: "Toa",
  "Deploy Service": "Chapisha Huduma Hii",
  Home: "Nyumbani",
  Organizations: "Mashirika",
  Portals: "Tovuti",
  "Workflow Marketplace": "Soko La Michakato",
  "Service Templates": "Sampuli Vya Huduma",
  Teams: "Wafanyakazi",
  Users: "Akaunti",
  Groups: "Vikundi",
  Departments: "Idara",
  "Account Settings": "Mipangilio ya Akaunti",
  Billing: "Miswada",
  Logout: "Kuondoka",
  Organization: "Mashirika",
  "Choose an Organization": "Chagua Shirika",
  "Organization Setup": "Sajili Shirika Lako",
  "Portals Setup": "Sajili Tovuti Yako",
  "Invite Workers": "Alika Wafanyakazi",
  "Billing Details": "Njia Ya Malipo",
  "General Details": "Maelezo ya Jumla",
};
